module.exports = __webpack_public_path__ + "assets/5dbe5dc83d8ac880b6563defa80929ee.png";